//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapGetters } from "vuex";
import draggable from "vuedraggable";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import QfMThemes from "../modals/qf-m-themes.vue";
import qfMAssistantAction from "../modals/qf-m-assistant-action.vue";
import SaveValidations from "../mixins/save-validations";

export default {
    name: "QfPageProperties",
    components: { QfMThemes, AQTooltip, qfMAssistantAction, AQDialog, draggable },
    mixins: [SaveValidations],
    data() {
        return {
            thumbStyle: {
                right: "-5px", borderRadius: "2px", width: "4px", opacity: 0.5
            },
            interfaceTypes: [{ label: "Fragment", value: "FRAGMENT" }, { label: "User interface", value: "GUI" }],
            scrollPaddingFix: { padding: "1px" },
            codeError: false,
            nameError: false,
            modalThemes: false,
            modalAssistant: false,
            pageLive: false,
            codeErrorLabel: null,
            nameErrorLabel: null,
            isInEdit: false,
            filteredDocList: [],
            draggableColumns: [],
            currentAssistantItem: {
                name: null,
                action: null,
                id: null,
                instructions: null,
                selectedDocs: [],
                additionalDocs: [],
                allowUserSelDocs: true,
                userPrompt: false,
                userRepliesPrompt: false
            },
            assistantListActions: [],
            deleteAlert: false,
            currentAiAction: null,
            firstLoad: false
        };
    },
    computed: {
        ...mapState("components", ["readOnly", "currentInterfaceProperties", "saveErrors", "appInterfaces", "activeInterface",
            "live", "properties", "aiActions"]),
        ...mapGetters("admin", ["featuresByTenant"]),
        readonlyPermission() {
            return this.$route.params && this.$route.params.permissions && this.$route.params.permissions.readonly;
        },
        legacyRenderer: {
            get() {
                return !this.$store.state.components.legacyRenderer;
            },
            set(value) {
                this.$store.commit("components/setLegacyRenderer", !value);
            }
        },
        draggableOptions() {
            return {
                draggable: this.readOnly || this.readonlyPermission ? "" : ".q-item",
                handle: ".drag-handle",
                ghostClass: "ghost",
                group: "assistantListActions",
                animation: 200
            };
        },
        showAiAssistant() {
            const isAIEnabled = this.featuresByTenant.find(element => element.code === "ENABLE_ASSISTANT" && element.enabled)
                && this.currentInterfaceProperties.type === "GUI";
            if (isAIEnabled) {
                Object.keys(this.properties).forEach(el => {
                    if (this.properties[el].__component === "ctrl-upload") {
                        this.filteredDocList.push({ label: this.properties[el].label, code: this.properties[el].__generics.code });
                    }
                });
            }
            return isAIEnabled;
        }
    },
    watch: {
        "currentInterfaceProperties.code": {
            handler() {
                this.codeError = false;
            },
            immediate: true
        },
        "currentInterfaceProperties.name": {
            handler() {
                this.nameError = false;
            },
            immediate: true
        },
        live: {
            handler(val) {
                this.pageLive = val;
            },
            immediate: true
        },
        pageLive(val) {
            this.$emit("liveTest", val);
            // this.setLive(val);
        },
        codeError(val) {
            if (!val) {
                this.codeErrorLabel = null;
            }
        },
        nameError(val) {
            this.nameErrorLabel = val ? this.$t("userInterface.nameMandatory") : null;
        },
        aiActions(val) {
            this.assistantListActions = val;
        },
        assistantListActions() {
            if (!this.firstLoad) {
                this.$root.$emit("showCheckedSaveBtn", false);
                this.$store.commit("main/setInterfaceDirty", true);
            }
            setTimeout(() => {
                this.firstLoad = false;
            }, 1000);
        },
        legacyRenderer() {
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$store.commit("main/setInterfaceDirty", true);
            this.dirty = true;
        }
    },
    created() {
        this.firstLoad = true;
        this.assistantListActions = [...this.aiActions];
        this.$root.$on("userInterfacesSave", this.validate);
        this.$root.$on("focusName", () => {
            this.focusName();
        });
    },
    beforeMount() {
        if (this.saveErrors) {
            this.validate();
            this.setSaveErrors(false);
        }
    },
    beforeDestroy() {
        this.$root.$off("userInterfacesSave", this.validate);
    },
    methods: {
        ...mapMutations("components", ["setSaveErrors", "updateColor", "setLive", "setAiActions"]),
        themes() {
            if (!this.readOnly && !this.readonlyPermission) {
                this.modalThemes = true;
            }
        },
        actionsList(data) {
            const index = this.assistantListActions.findIndex(el => el.id === data.id);
            if (index === -1) {
                this.assistantListActions.push(data);
            } else {
                this.assistantListActions[index] = data;
            }
            this.setAiActions(this.assistantListActions);
        },
        openDeleteAlert(item) {
            this.currentAiAction = item;
            this.deleteAlert = true;
        },
        deleteAiAction() {
            this.assistantListActions = this.assistantListActions.filter(el => el.id !== this.currentAiAction.id);
            this.setAiActions(this.assistantListActions);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$store.commit("main/setInterfaceDirty", true);
            this.currentAiAction = null;
        },
        onChangeItms(event) {
            if (event.moved) {
                this.setAiActions(this.assistantListActions);
            }
        },
        getLabelAction(act) {
            let label = "";
            switch (act) {
                case "summarize":
                    label = this.$t("userInterface.auraAssist.summarizeAct");
                    break;
                case "targeted":
                    label = this.$t("userInterface.auraAssist.targetedSum");
                    break;
                case "custom":
                    label = this.$t("userInterface.auraAssist.custom");
                    break;
                case "conversation":
                    label = this.$t("userInterface.auraAssist.conversationAct");
                    break;
                default:
                    label = "";
                    break;
            }
            return label;
        },
        openAssistantModal(item) {
            if (!this.readOnly && !this.readonlyPermission) {
                this.isInEdit = !!item;
                if (item) {
                    this.currentAssistantItem = item;
                } else {
                    this.currentAssistantItem = {
                        name: null,
                        action: null,
                        id: null,
                        instructions: null,
                        selectedDocs: [],
                        additionalDocs: [],
                        allowUserSelDocs: true,
                        userPrompt: false,
                        userRepliesPrompt: false
                    };
                }
                this.filteredDocList = [];
                this.modalAssistant = true;
            }
        },
        focusName() {
            const { nameInterface } = this.$refs;
            if (nameInterface) {
                nameInterface.focus();
            }
        },
        validate() {
            const { code = "", name = "" } = this.currentInterfaceProperties;
            const validateCode = this.__validateCode(code);
            const validateName = this.__validateName(name);

            if (validateCode !== 0) {
                this.codeErrorLabel = validateCode === -2 ? this.$t("userInterface.duplicateCode") : this.$t("userInterface.codeMandatory");
                this.codeError = true;
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("userInterface.duplicateCodeToast")
                });
                this.$emit("duplicatedCode");
            }

            if (validateName !== 0) {
                this.nameError = true;
            }
        }
    }
};
